import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { renderError } from 'services/gecko-error';
import GeckoRequest from 'services/gecko-request';
import { GECKO_CONSTS, GeckoCardForm, GeckoToastService } from 'ui';

class Password extends Component {
  constructor(props) {
    super(props);
    this.state = {
      passwordValues: {
        current_password: '',
        new_password: '',
        confirm_new_password: '',
      },
    };
  }

  passwordFields = [
    {
      label: 'Current password',
      key: 'current_password',
      type: GECKO_CONSTS.FIELD_TYPE_PASSWORD,
    },
    {
      label: 'New password',
      key: 'new_password',
      type: GECKO_CONSTS.FIELD_TYPE_PASSWORD,
    },
    {
      label: 'Confirm new password',
      key: 'confirm_new_password',
      type: GECKO_CONSTS.FIELD_TYPE_PASSWORD,
    },
  ];

  setPasswordButton = {
    name: 'Update password',
    handler: () => {
      if (!this.state.passwordValues.current_password) {
        return new GeckoToastService().error(
          'You must provide your current password'
        );
      }
      if (!this.state.passwordValues.new_password) {
        return new GeckoToastService().error('You must provide a new password');
      }
      if (
        this.state.passwordValues.confirm_new_password !==
        this.state.passwordValues.new_password
      ) {
        return new GeckoToastService().error(
          'New password and Confirm password do not match'
        );
      }

      GeckoRequest.post('/user/change_password', {
        current: this.state.passwordValues.current_password,
        password: this.state.passwordValues.new_password,
      })
        .then(() => {
          new GeckoToastService().success('Your password has been changed');
          this.setState({
            passwordValues: {
              current_password: '',
              new_password: '',
              confirm_new_password: '',
            },
          });
        })
        .catch(renderError);
    },
  };

  handlePasswordInputChange(key, value) {
    const newPasswordValues = Object.assign({}, this.state.passwordValues, {
      [key]: value,
    });
    this.setState({ passwordValues: newPasswordValues });
  }

  render() {
    if (this.props.agent_id !== this.props.loggedInUser.id) {
      return null;
    } else {
      return (
        <GeckoCardForm
          name="Change password"
          fields={this.passwordFields}
          values={this.state.passwordValues}
          headerBtns={[]}
          footerBtns={[this.setPasswordButton]}
          handler={this.handlePasswordInputChange.bind(this)}
        />
      );
    }
  }
}

Password.defaultProps = {};

Password.propTypes = {
  agent_id: PropTypes.number.isRequired,
  loggedInUser: PropTypes.object.isRequired,
};

export default Password;
